import { Component } from 'preact'

import { Heading1 } from '../textNodes'
import LoginForm from '../userPopup/loginForm'

const { isOnMobile } = window.application || {}
const INPUT_FOCUS_DELAY = 100

export default class LoginPage extends Component {
  componentDidMount() {
    this.focusLoginInputIfNeeded()
  }

  focusLoginInputIfNeeded() {
    if (!isOnMobile) {
      setTimeout(() => this.loginInput?.focus(), INPUT_FOCUS_DELAY)
    }
  }

  render() {
    return (
      <div className="loginPage">
        <div className="loginPage-header">
          <Heading1 html={ I18n.t('login.heading') } />
        </div>

        <LoginForm skipHeading inputRef={ el => this.loginInput = el } />
      </div>
    )
  }
}
